import { lazy } from "react";

const ManagerReport = lazy(() => import("./ManagerReport"));

/**
 * Ruta del reporte gerencial por correo. COT-143 / Mejora 1.
 */
const ManagerReportConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "configuracion/reporte-gerencial",
      element: <ManagerReport />,
    },
  ],
};

export default ManagerReportConfig;
